import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

import ReportType from "../../enum/ReportType";

import MapFilter from "./enums/MapFilter";

const reportsAnalytics = new AnalyticsService("Reports");

const reportTabKeyToFeature: Record<string, string[]> = {
  [ReportType.ACTIVITY]: ["Activity"],
  [ReportType.DEALS]: ["Deals"],
  [ReportType.EXPORTS]: ["Exports"],
  [ReportType.LEADERBOARD]: ["Leaderboard"],
  [ReportType.OVERVIEW]: ["Overview"],
  [ReportType.WEEKLY_REPORT_CARD]: ["Weekly Report Card"],
};

export const getAnalyticIssuerByTabKey = (key: string): AnalyticsService =>
  reportsAnalytics.extend(reportTabKeyToFeature[key] || []);

export const tabReportClick = (key: string) => {
  if (reportTabKeyToFeature[key]) {
    reportsAnalytics.clicked(reportTabKeyToFeature[key]);
  }
};

const pathByMapFilter: Record<string, string[]> = {
  [MapFilter.ALL_DEALS]: ["All Deals"],
  [MapFilter.AUTO_ACTIVITIES]: ["Verified (Auto) Activities"],
  [MapFilter.CLOSED_LOST_REVENUE]: ["Closed Lost Revenue"],
  [MapFilter.CLOSED_WON_REVENUE]: ["Closed Won Revenue"],
  [MapFilter.COMPANIES_30_DAYS_NO_CONTACT]: ["Companies > 30 Days No Contact"],
  [MapFilter.COMPANIES_OVER_CADENCE]: ["Companies Over Cadence"],
  [MapFilter.COMPLETED_ACTIVITIES]: ["Activities Done"],
  [MapFilter.DEALS_30_DAYS_NO_CONTACT]: [" Deals > 30 Days No Contact"],
  [MapFilter.GROSS_OPEN_REVENUE]: ["Gross Open Revenue"],
  [MapFilter.NUMBER_OF_CLOSED_LOST_DEALS]: ["Num Deals Closed Lost"],
  [MapFilter.NUMBER_OF_CLOSED_WON_DEALS]: ["Num Deals Closed Won"],
  [MapFilter.OVERDUE_ACTIVITIES]: ["Overdue Activities"],
  [MapFilter.PEOPLE_30_DAYS_NO_CONTACT]: ["People > 30 Days No Contact"],
  [MapFilter.PEOPLE_OVER_CADENCE]: ["People Over Cadence"],
  [MapFilter.RECENTLY_CLOSED_DEALS]: [" Recently Closed Won/Lost"],
  [MapFilter.TOP_10_DEALS]: ["Top 10 Deals"],
};

export const getFeaturePathByMapFilter = (key: string): string[] => pathByMapFilter[key] || [];

export const reportsOverviewAnalytics = reportsAnalytics.extend("Overview");
export const reportsActivityAnalytics = reportsAnalytics.extend("Activity");
export const reportsDealsAnalytics = reportsAnalytics.extend("Deals");
export const reportsLastLocationAnalytics = reportsAnalytics.extend("Last Location");
export const reportsExportsAnalytics = reportsAnalytics.extend("Exports");
export const reportsWeeklyCardAnalytics = reportsAnalytics.extend("Weekly Report Card");

export default reportsAnalytics;
